import { useCallback, useState } from "react";

const STORAGE_PREFIX = "assistant-cta-dismissed:";

export function useSessionDismiss(key: string): [boolean, () => void] {
  const storageKey = `${STORAGE_PREFIX}${key}`;
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(storageKey) === "1";
    } catch {
      return false;
    }
  });

  const dismiss = useCallback(() => {
    try {
      sessionStorage.setItem(storageKey, "1");
    } catch {
      // sessionStorage may be unavailable (e.g. private mode); dismiss in-memory only.
    }
    setDismissed(true);
  }, [storageKey]);

  return [dismissed, dismiss];
}
